import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
  AUTHENTICATED,
  HIDE_AUTH_MESSAGE,
  SHOW_AUTH_MESSAGE,
  SHOW_AUTH_SUCCESS_MESSAGE,
  SHOW_LOADING,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNOUT_SUCCESS,
  SIGNUP_SUCCESS,
  REDIRECT_TO_VERIFY_EMAIL,
  REDIRECT_TO_CONFIGURE_MFA,
  SHOW_MFA_VERIFICATION,
  HIDE_MFA_VERIFICATION,
  MFA_VERIFICATION_SUCCESS,
} from "../constants/Auth";

const initState = {
  loading: false,
  message: "",
  showMessage: false,
  messageType: "error", // "error" ou "success"
  redirect: "",
  user: undefined,
  showMfaVerification: false,
  mfaResolver: null,
  userEmail: null,
};

const auth = (state = initState, action) => {
  switch (action.type) {
    case AUTHENTICATED:
      return {
        ...state,
        loading: false,
        redirect: APP_PREFIX_PATH,
        user: action.user,
      };
    case SHOW_AUTH_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        messageType: "error",
        loading: false,
      };
    case SHOW_AUTH_SUCCESS_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        messageType: "success",
        loading: false,
      };
    case HIDE_AUTH_MESSAGE:
      return {
        ...state,
        message: "",
        showMessage: false,
        // Manter o messageType atual em vez de resetar para "error"
      };
    case SIGNOUT_SUCCESS: {
      return {
        ...state,
        user: undefined,
        redirect: "/",
        loading: false,
      };
    }
    case SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case REDIRECT_TO_VERIFY_EMAIL: {
      return {
        ...state,
        loading: false,
        redirect: "/auth/verify-email",
      };
    }
    case REDIRECT_TO_CONFIGURE_MFA: {
      return {
        ...state,
        loading: false,
        redirect: "/auth/configure-mfa",
      };
    }
    case SHOW_MFA_VERIFICATION: {
      return {
        ...state,
        loading: false,
        showMfaVerification: true,
        mfaResolver: action.payload.resolver,
        userEmail: action.payload.email,
        message: "",
        showMessage: false,
      };
    }
    case HIDE_MFA_VERIFICATION: {
      return {
        ...state,
        showMfaVerification: false,
        mfaResolver: null,
        userEmail: null,
      };
    }
    case MFA_VERIFICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        showMfaVerification: false,
        mfaResolver: null,
        userEmail: null,
        redirect: APP_PREFIX_PATH,
        token: action.token,
      };
    }
    default:
      return state;
  }
};

export default auth;
